import { BusinessClock } from '../../core/time/business-clock.service';
import { ReservationCsvComponent } from './reservation-csv.component';
import { clockView } from '../../core/time/business-time';
import { businessDayjs } from '../../core/time/business-calendar';
import { jstCalendarPlugin, calendarNow } from '../../core/time/business-calendar';
import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DatePipe, DecimalPipe } from '@angular/common';
import { PageTitleService } from '../../core/services/page-title.service';
import { StudioService } from '../../core/services/studio.service';
import { PtReservationService } from '../../core/services/pt-reservation.service';
import { PtReservationScheduleService } from '../../core/services/pt-reservation-schedule.service';
import { PtReservationMenuService } from '../../core/services/pt-reservation-menu.service';
import { MemberService } from '../../core/services/member.service';
import { StudioSelectionService } from '../../core/services/studio-selection.service';
import { PagerComponent } from '../../shared/components/pager.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';
import { Calendar } from '@fullcalendar/core';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';
import {
  JAPANESE_HOLIDAY_SOURCE_ID,
  loadJapaneseHolidayEvents,
} from '../../shared/utils/japanese-holiday-calendar';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/ja';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('ja');

const SESSION_KEY = 'pt_reservation_select_studio_id';
const RESERVE_START = 9;
const RESERVE_END = 21;
const RESERVE_SLOT = 15;
const STATUS_COLORS = [
  { backgroundColor: '#fbf202', textColor: '#4EBCC4', borderColor: '#fbf202' },
  { backgroundColor: '#4EBCC4', textColor: '#ffffff', borderColor: '#4EBCC4' },
  { backgroundColor: '#D1F0F2', textColor: '#4EBCC4', borderColor: '#D1F0F2' },
  { backgroundColor: '#E9ECEF', textColor: '#6C757D', borderColor: '#E9ECEF' },
  { backgroundColor: '#555', textColor: '#eee', borderColor: '#666' },
  { backgroundColor: '#4EBCC4', textColor: '#ffffff', borderColor: '#4EBCC4' },
  { backgroundColor: '#ffffff', textColor: '#2A9EA6', borderColor: '#4EBCC4' },
];
const STATUS_TEXT = ['予約受付', '予約確定', '実施済', 'キャンセル'];

@Component({
    selector: 'app-pt-reservation-list',
    imports: [RouterLink, FormsModule, DatePipe, DecimalPipe, PagerComponent, FlashMessageComponent, ReservationCsvComponent],
    template: `
<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <span><i class="fa s-icon-list"></i> 予約一覧</span>
        </div>
        <div class="card-body">
          <div><app-flash-message></app-flash-message></div>
          <form novalidate name="myForm">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group row align-items-end">
                  <div class="form-group col-md-8">
                    <label class="col-form-label" for="studio_name">店舗</label>
                    <select class="form-control" id="studio_name" name="studio_name"
                      [(ngModel)]="selectedStudio" (ngModelChange)="onStudioChange()">
                      <option [ngValue]="null">-- 選択してください --</option>
                      @for (s of studios; track s.id) {
                        <option [ngValue]="s">{{s.name}}</option>
                      }
                    </select>
                  </div>
                  <div class="form-group col-md-4">
                    <button class="btn btn-outline-primary" type="button"
                      [disabled]="isButtonDisabled || !selectedStudio" (click)="load()">
                      <span class="material-symbols-outlined align-bottom mr-1">cycle</span>&nbsp;更新
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <hr>
        </div>
        <div class="col-md-12">
          <button class="form-group btn btn-primary text-white" type="button"
            [disabled]="!selectedStudio" (click)="openCreateModal()">
            <span class="material-symbols-outlined align-bottom mr-1">edit</span>&nbsp;予約作成
          </button>
          <button class="form-group btn btn-primary text-white" type="button"
            [disabled]="!selectedStudio" (click)="openDummyModal()">
            <span class="material-symbols-outlined align-bottom mr-1">add_moderator</span>&nbsp;ブロック予約作成
          </button>
          <app-reservation-csv></app-reservation-csv>
        </div>
        <div class="col-md-12">
          <button class="form-group btn btn-gray-600" type="button" (click)="toggleShowOverdueTasks()">
            <span class="material-symbols-outlined align-bottom">switch_access_2</span>
            &nbsp;{{showOverdueTasks ? '予約一覧' : '未対応予約'}}表示
          </button>
        </div>
        <div class="card-body" [style.display]="showOverdueTasks ? 'block' : 'none'">
          @if (selectedStudio) {
            @if (!searching && overdueTasks.length === 0) {
              <span>該当するデータはありません</span>
            }
            @if (overdueTasks.length > 0) {
              <app-pager [pageIndex]="overduePageIndex" [totalPages]="overdueTotalPages" (pageChange)="overduePageIndex = $event"></app-pager>
              <table class="table table-bordered table-sm table-hover table-ptb-0">
                <thead>
                  <tr>
                    <th width="10%">状態</th>
                    <th width="15%">開始日時</th>
                    <th width="15%">終了日時</th>
                    <th width="10%">会員ID</th>
                    <th width="15%">氏名</th>
                    <th width="30%">メニュー名</th>
                    <th width="10%"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (item of pagedOverdueTasks; track item.id) {
                    <tr>
                      <td class="text-center">
                        @if (item.status === 0) { <span>予約受付</span> }
                        @if (item.status === 1) { <span>予約確定</span> }
                      </td>
                      <td>{{item.startedAt | date:'yyyy/MM/dd HH:mm'}}</td>
                      <td>{{item.endedAt | date:'yyyy/MM/dd HH:mm'}}</td>
                      <td>{{item.member?.memberCode}}</td>
                      <td>{{item.member?.lastName}} {{item.member?.firstName}}</td>
                      <td>{{item.reservationMenu?.menuName}}</td>
                      <td class="text-center">
                        <button type="button" class="mt-1 mb-1 btn btn-primary btn-sm text-white"
                          (click)="setSelectReservation(item); showReservationModal = true">
                          <span class="material-symbols-outlined align-bottom" title="予約詳細">info</span>
                        </button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              <app-pager [pageIndex]="overduePageIndex" [totalPages]="overdueTotalPages" (pageChange)="overduePageIndex = $event"></app-pager>
            }
          }
        </div>
        <div class="card-body" [style.display]="!showOverdueTasks ? 'block' : 'none'">
          <div id="calendar" [style.display]="selectedStudio ? 'block' : 'none'"></div>
        </div>
      </div>
    </div>
  </div>
</div>

@if (showReservationModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title"><i class="fa fa-calendar"></i>&nbsp;予約</h5>
          <button type="button" class="close" (click)="showReservationModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            @if (!isConfirmation) {
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 col-form-label">
                    <div class="d-flex justify-content-end" style="gap: 1rem;">
                      @if (selectReservation.memberName === 'ブロック予約' || selectReservation.status === 3) {
                        <button class="btn btn-danger" type="button" (click)="showConfirm('destroy')">
                          <i class="fa s-icon-delete"></i>&nbsp;削除
                        </button>
                      }
                      @if (selectReservation.memberName !== 'ブロック予約' && (selectReservation.status === 0 || selectReservation.status === 1)) {
                        <button class="btn btn-danger" type="button" (click)="showConfirm('cancel')">
                          <i class="fa s-icon-delete"></i>&nbsp;予約キャンセル
                        </button>
                      }
                      @if (selectReservation.memberName !== 'ブロック予約' && selectReservation.status === 0) {
                        <button class="btn btn-success" type="button" (click)="showConfirm('confirm')">
                          <i class="fa fa-calendar-check-o"></i>&nbsp;予約確定
                        </button>
                      }
                      @if (selectReservation.memberName !== 'ブロック予約' && selectReservation.status === 1) {
                        <button class="btn btn-success" type="button" (click)="showConfirm('complete')">
                          <i class="fa fa-check-circle"></i>&nbsp;実施済
                        </button>
                      }
                    </div>
                  </div>
                </div>
                <br>
                <div class="row">
                  <label class="col-md-4 col-form-label">予約日</label>
                  <div class="col-md-8 col-form-label"><label>{{selectReservation.targetDay}}</label></div>
                </div>
                <div class="row">
                  <label class="col-md-4 col-form-label">開始時間</label>
                  <div class="col-md-8 col-form-label"><label>{{selectReservation.targetStart}}</label></div>
                </div>
                <div class="row">
                  <label class="col-md-4 col-form-label">終了時間</label>
                  <div class="col-md-8 col-form-label"><label>{{selectReservation.targetEnd}}</label></div>
                </div>
                <br>
                <div class="row">
                  <label class="col-md-4 col-form-label">状態</label>
                  <div class="col-md-8 col-form-label"><label>{{selectReservation.statusStr}}</label></div>
                </div>
                <hr>
                <div class="row">
                  <label class="col-md-4 col-form-label">メニュー</label>
                  <div class="col-md-8 col-form-label">
                    <table class="table table-bordered table-sm table-hover table-ptb-0">
                      <thead>
                        <tr>
                          <th width="80%">メニュー名</th>
                          <th width="20%">金額</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{selectReservation.reservationMenu?.menuName}}</td>
                          <td>¥{{ selectReservation.amount | number:'1.0-0' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <label class="col-md-4 col-form-label">会員ID</label>
                  <div class="col-md-8 col-form-label"><label>{{selectReservation.member?.memberCode}}</label></div>
                </div>
                <div class="row">
                  <label class="col-md-4 col-form-label">会員氏名</label>
                  <div class="col-md-8 col-form-label"><label>{{selectReservation.memberName}}</label></div>
                </div>
                <div class="row">
                  <label class="col-md-4 col-form-label">電話番号</label>
                  <div class="col-md-8 col-form-label"><label>{{selectReservation.member?.phone}}</label></div>
                </div>
                <div class="row">
                  <label class="col-md-4 col-form-label">メールアドレス</label>
                  <div class="col-md-8 col-form-label"><label>{{selectReservation.member?.email ?? selectReservation.email}}</label></div>
                </div>
                <hr>
                <div class="row">
                  <label class="col-md-4 col-form-label">連絡事項</label>
                  <div class="col-md-8 col-form-label" style="overflow-wrap: anywhere">
                    <label>{{selectReservation.note}}</label>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <label class="col-md-12 col-form-label">PT売上</label>
                  <div class="col-md-12 col-form-label">
                    @if (!ptTransactions.length) {
                      <label>該当するデータはありません。</label>
                    }
                    @if (ptTransactions.length) {
                      <app-pager [pageIndex]="ptPageIndex" [totalPages]="ptTotalPages" (pageChange)="ptPageIndex = $event"></app-pager>
                      <table class="table table-bordered table-sm table-hover table-ptb-0">
                        <thead>
                          <tr>
                            <th style="width: 3%;"></th>
                            <th style="width: 10%;">状態</th>
                            <th>売上年月</th>
                            <th>売上タイプ</th>
                            <th>明細</th>
                            <th>金額</th>
                            <th>支払方法</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (tx of pagedPtTransactions; track tx.id) {
                            <tr>
                              <td class="text-center text-white"
                                  [class.bg-warning]="tx.status === 6 && tx.invoice != null && tx.invoice.retryCount === 0"
                                  [class.bg-danger]="tx.status === 6 && tx.invoice != null && tx.invoice.retryCount > 0 && tx.invoice.retryCount !== 9 && tx.invoice.retryCount !== 99">
                                @if (tx.status === 6 && tx.invoice != null && tx.invoice.retryCount !== 9 && tx.invoice.retryCount !== 99) {
                                  <span>{{ tx.invoice.retryCount + 1 }}</span>
                                }
                              </td>
                              <td class="text-center">
                                @if (tx.status === 0) { <span class="text-warning"><i class="fa s-icon-schedule fa-2x fa-fw"></i></span> }
                                @if (tx.status === 1) { <span class="text-secondary"><i class="fa s-icon-close fa-2x fa-fw"></i></span> }
                                @if (tx.status === 2) { <span class="text-warning"><i class="fa s-icon-waiting fa-2x fa-fw"></i></span> }
                                @if (tx.status === 3) { <span class="text-primary"><i class="fa fa-gavel fa-2x fa-fw"></i></span> }
                                @if (tx.status === 4) { <span class="text-secondary"><i class="fa fa-times-circle fa-2x fa-fw"></i></span> }
                                @if (tx.status === 5) { <span [class]="tx.isOvercharged ? 'text-danger' : 'text-success'"><i class="fa s-icon-finished fa-2x fa-fw"></i></span> }
                                @if (tx.status === 6) { <span class="text-danger"><i class="fa s-icon-attention fa-2x fa-fw"></i></span> }
                                @if (tx.status === 7) { <span class="text-success"><i class="fa s-icon-back fa-2x fa-fw"></i></span> }
                                @if (tx.status === 8) { <span class="text-secondary"><span class="material-icons-outlined fa-2x fa-fw">do_disturb_on</span></span> }
                                @if (tx.status === 9) { <span class="text-success"><i class="fa s-icon-cashPay fa-2x fa-fw"></i></span> }
                              </td>
                              <td>{{tx.yearPay}}年{{tx.monthPay}}月</td>
                              <td>
                                @if (tx.chargeType === 0) { <span>その他</span> }
                                @if (tx.chargeType === 1) { <span>月会費</span> }
                                @if (tx.chargeType === 2) { <span>入会金・事務手数料</span> }
                                @if (tx.chargeType === 3) { <span>ロッカー費</span> }
                                @if (tx.chargeType === 4) { <span>PT費</span> }
                                @if (tx.chargeType === 5) { <span>物販</span> }
                              </td>
                              <td>{{tx.title}}</td>
                              <td><span class="pull-right">¥{{ tx.amount | number:'1.0-0' }}</span></td>
                              <td>
                                @if (tx.paymentMethod === 0) { <span>口座振替</span> }
                                @if (tx.paymentMethod === 1) { <span>クレジット</span> }
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                      <app-pager [pageIndex]="ptPageIndex" [totalPages]="ptTotalPages" (pageChange)="ptPageIndex = $event"></app-pager>
                    }
                  </div>
                </div>
              </div>
            }
            @if (isConfirmation && confirmAction === 'confirm') {
              <div class="col-md-12">
                <label class="col-md-12">予約確定に変更します。よろしいですか。</label>
              </div>
            }
            @if (isConfirmation && confirmAction === 'complete') {
              <div class="col-md-12">
                <label class="col-md-12">実施済に変更します。よろしいですか。</label>
              </div>
            }
            @if (isConfirmation && confirmAction === 'destroy') {
              <div class="col-md-12">
                <label class="col-md-12">予約を削除します。よろしいですか。</label>
              </div>
            }
            @if (isConfirmation && confirmAction === 'cancel') {
              <div class="col-md-12">
                <label class="col-md-12">予約キャンセルに変更します。よろしいですか。</label>
              </div>
            }
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn bg-close text-white" type="button" (click)="showReservationModal = false">
            <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
          </button>
          @if ((selectReservation.memberName === 'ブロック予約' || selectReservation.status === 3) && confirmAction === 'destroy') {
            <button class="btn btn-danger" type="button" (click)="destroy()">
              <i class="fa s-icon-delete"></i>&nbsp;削除
            </button>
          }
          @if ((selectReservation.status === 0 || selectReservation.status === 1) && confirmAction === 'cancel') {
            <button class="btn btn-danger" type="button" (click)="remove()">
              <i class="fa s-icon-delete"></i>&nbsp;予約キャンセル
            </button>
          }
          @if (selectReservation.status === 0 && confirmAction === 'confirm') {
            <button class="btn btn-success" type="button" (click)="save('confirm')">
              <i class="fa fa-calendar-check-o"></i>&nbsp;予約確定
            </button>
          }
          @if (selectReservation.status === 1 && confirmAction === 'complete') {
            <button class="btn btn-success" type="button" (click)="save('complete')">
              <i class="fa fa-check-circle"></i>&nbsp;実施済
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (showCreateModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">予約作成</h5>
          <button type="button" class="close" (click)="showCreateModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form novalidate #createForm="ngForm">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">予約日</label>
                  <div class="col-md-8">
                    <select class="form-control" [(ngModel)]="newReservation.targetDay" name="targetDay" required>
                      <option value="">-- 選択してください --</option>
                      @for (d of scheduleDate; track d.id) {
                        <option [ngValue]="d.id">{{d.name}}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">開始時間</label>
                  <div class="col-md-8">
                    <select class="form-control" [(ngModel)]="newReservation.startTime" name="startTime" required>
                      <option value="">-- 選択してください --</option>
                      @for (t of scheduleTime; track t.id) {
                        <option [ngValue]="t.id">{{t.name}}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">メニュー</label>
                  <div class="col-md-8">
                    <select class="form-control" [(ngModel)]="newReservation.reservationMenuId" name="reservationMenuId" required>
                      <option value="">-- 選択してください --</option>
                      @for (m of menuList; track m.id) {
                        <option [ngValue]="m.id">{{m.displayName}}</option>
                      }
                    </select>
                  </div>
                </div>
                <br>
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">対象会員</label>
                  <div class="col-md-8">
                    <input type="text" class="form-control" [(ngModel)]="searchText" name="searchText" placeholder="検索">
                    <select class="form-control" [(ngModel)]="newReservation.memberId" name="memberId"
                      (ngModelChange)="selectMember($event)" required>
                      <option value="">-- 選択してください --</option>
                      @for (m of filteredMemberList; track m.id) {
                        <option [ngValue]="m.id">{{m.name}}</option>
                      }
                    </select>
                  </div>
                </div>
                @if (newReservation.memberId && selectedMember) {
                  <div class="form-group row">
                    <label class="col-md-4 col-form-label">会員ID</label>
                    <label class="col-md-8 col-form-label">{{selectedMember.data?.memberCode}}</label>
                    <label class="col-md-4 col-form-label">会員名</label>
                    <label class="col-md-8 col-form-label">{{selectedMember.data?.lastName}} {{selectedMember.data?.firstName}}<br>({{selectedMember.data?.lastNameKana}} {{selectedMember.data?.firstNameKana}})</label>
                    <label class="col-md-4 col-form-label">区分コース</label>
                    <label class="col-md-8 col-form-label">{{selectedMember.data?.studioPlan?.name}}</label>
                    <label class="col-md-4 col-form-label">住所</label>
                    <label class="col-md-8 col-form-label">〒 {{selectedMember.data?.zip}}<br>{{selectedMember.data?.province}}<br>{{selectedMember.data?.city}}<br>{{selectedMember.data?.area}}<br>{{selectedMember.data?.address}}</label>
                    <label class="col-md-4 col-form-label">生年月日</label>
                    <label class="col-md-8 col-form-label">{{selectedMember.data?.birthday}}</label>
                    <label class="col-md-4 col-form-label">電話番号</label>
                    <label class="col-md-8 col-form-label">{{selectedMember.data?.phone}}</label>
                    <label class="col-md-4 col-form-label">メールアドレス</label>
                    <label class="col-md-8 col-form-label">{{selectedMember.data?.email}}</label>
                  </div>
                }
                <br>
                <div class="form-group row">
                  <label class="col-md-12 col-form-label" style="text-decoration: underline; text-decoration-color: #4EBCC4;">
                    この画面からの予約は受付時間などの制限を受けません。<br>予約状況を十分にご確認のうえ、ご登録ください。
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn bg-close text-white" type="button" (click)="showCreateModal = false">
              <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
            </button>
            <button type="button" class="btn btn-success" [disabled]="createForm.invalid" (click)="saveNew()">
              <i class="fa s-icon-save fa-fw"></i>&nbsp;保存
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}

@if (showDummyModal) {
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ブロック予約作成</h5>
          <button type="button" class="close" (click)="showDummyModal = false">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form novalidate #dummyForm="ngForm">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">設定日</label>
                  <div class="col-md-8">
                    <select class="form-control" [(ngModel)]="dummyReservation.targetDay" name="targetDay" required>
                      <option value="">-- 選択してください --</option>
                      @for (d of scheduleDate; track d.id) {
                        <option [ngValue]="d.id">{{d.name}}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">開始時間</label>
                  <div class="col-md-8">
                    <select class="form-control" [(ngModel)]="dummyReservation.startTime" name="startTime" required>
                      <option value="">-- 選択してください --</option>
                      @for (t of scheduleTime; track t.id) {
                        <option [ngValue]="t.id">{{t.name}}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">終了時間</label>
                  <div class="col-md-8">
                    <select class="form-control" [(ngModel)]="dummyReservation.endTime" name="endTime" required>
                      <option value="">-- 選択してください --</option>
                      @for (t of scheduleTime; track t.id) {
                        @if (!dummyReservation.startTime || t.id > dummyReservation.startTime) {
                          <option [ngValue]="t.id">{{t.name}}</option>
                        }
                      }
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-md-4 col-form-label">連絡事項</label>
                  <div class="col-md-8">
                    <input type="text" class="form-control" [(ngModel)]="dummyReservation.note" name="note">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn bg-close text-white" type="button" (click)="showDummyModal = false">
              <i class="fa s-icon-cancel fa-fw"></i>&nbsp;閉じる
            </button>
            <button type="button" class="btn btn-success" [disabled]="dummyForm.invalid" (click)="dummy()">
              <i class="fa s-icon-save fa-fw"></i>&nbsp;保存
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}
  `
})
export class PtReservationListComponent implements OnInit, AfterViewInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitleService = inject(PageTitleService);
  private studioService = inject(StudioService);
  private ptReservationService = inject(PtReservationService);
  private flash = inject(FlashService);
  private ptScheduleService = inject(PtReservationScheduleService);
  private ptMenuService = inject(PtReservationMenuService);
  private memberService = inject(MemberService);
  private studioSelection = inject(StudioSelectionService);

  studios: any[] = [];
  selectedStudio: any = null;
  items: any[] = [];
  overdueTasks: any[] = [];
  schedules: any[] = [];
  searching = false;
  isButtonDisabled = false;
  showOverdueTasks = false;

  showReservationModal = false;
  showCreateModal = false;
  showDummyModal = false;

  selectReservation: any = {};
  isConfirmation = false;
  confirmAction: string | null = null;
  ptTransactions: any[] = [];
  readonly pageSize = 20;
  overduePageIndex = 0;
  ptPageIndex = 0;

  get overdueTotalPages(): number { return Math.ceil(this.overdueTasks.length / this.pageSize); }
  get ptTotalPages(): number { return Math.ceil(this.ptTransactions.length / this.pageSize); }
  get pagedOverdueTasks(): any[] {
    return this.overdueTasks.slice(this.overduePageIndex * this.pageSize, (this.overduePageIndex + 1) * this.pageSize);
  }
  get pagedPtTransactions(): any[] {
    return this.ptTransactions.slice(this.ptPageIndex * this.pageSize, (this.ptPageIndex + 1) * this.pageSize);
  }

  newReservation: any = {};
  searchText = '';
  selectedMember: any = null;
  dummyReservation: any = {};
  memberList: any[] = [];
  menuList: any[] = [];

  readonly scheduleDate = this.getScheduleDate();
  readonly scheduleTime = this.getScheduleTime();

  private calendar: Calendar | null = null;
  private holidayLoadId = 0;
  private viewInitialized = false;
  private restoredStudioLoaded = false;

  get filteredMemberList(): any[] {
    if (!this.searchText) return this.memberList;
    const lower = this.searchText.toLowerCase();
    return this.memberList.filter(m => m.name.toLowerCase().includes(lower));
  }

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('予約管理', 'fa fa-calendar');
    this.studios = await this.studioService.list('all') ?? [];
    const restored = this.studioSelection.restore(this.studios, SESSION_KEY);
    if (restored) {
      this.selectedStudio = restored;
    }
    await this.loadRestoredStudio();
  }

  ngAfterViewInit(): void {
    this.viewInitialized = true;
    this.initCalendar();
    void this.loadRestoredStudio();
  }

  private initCalendar(): void {
    const calendarEl = document.getElementById('calendar');
    if (!calendarEl) return;
    this.calendar = new Calendar(calendarEl, {
      plugins: [jstCalendarPlugin, timeGridPlugin, interactionPlugin, listPlugin],
      timeZone: 'Asia/Tokyo', now: calendarNow,
      locale: 'ja',
      contentHeight: 'auto',
      initialView: 'timeGridDay',
      slotMinTime: `${String(RESERVE_START).padStart(2, '0')}:00:00`,
      slotMaxTime: `${String(RESERVE_END + 1).padStart(2, '0')}:00:00`,
      slotLabelInterval: `00:${String(RESERVE_SLOT).padStart(2, '0')}:00`,
      slotDuration: `00:${String(RESERVE_SLOT).padStart(2, '0')}:00`,
      slotEventOverlap: false,
      eventDisplay: 'block',
      noEventsContent: '該当するデータがありません。',
      titleFormat: { year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short' },
      eventTimeFormat: { hour: '2-digit', minute: '2-digit' },
      slotLabelFormat: { hour12: false, hour: '2-digit', minute: '2-digit', omitZeroMinute: false, meridiem: false },
      eventMinHeight: 15,
      nowIndicator: true,
      allDaySlot: false,
      headerToolbar: { end: 'listDay,timeGridDay,timeGridWeek today prev,next' },
      views: {
        timeGridMonth: {
          type: 'timeGrid',
          duration: { days: 30 },
          buttonText: '30days',
          dayHeaderFormat: { month: 'numeric', day: 'numeric', weekday: 'short' },
        },
      },
      dayHeaderContent: (arg: any) => {
        const scheduleData = this.schedules.find(v => v.date === businessDayjs(arg.date).format('YYYY-MM-DD')) ?? {};
        return {
          html: `
            <div class="mb-1"><span>${arg.text}</span></div>
            <div class="d-flex flex-column align-items-start" style="font-weight: normal; font-size: .85em">
              <span>${scheduleData.main || '　'}</span>
              <span>${scheduleData.sub || '　'}</span>
            </div>
          `,
        };
      },
      eventDataTransform: (eventData: any) => {
        if (eventData?.extendedProps?.type === 'holiday') return eventData;
        if (eventData?.url) {
          return {
            ...eventData,
            type: 'holiday',
            allDay: false,
            start: businessDayjs(eventData.start).hour(0).minute(0).second(0).toISOString(),
            end: businessDayjs(eventData.start).hour(24).minute(0).second(0).toISOString(),
          };
        }
        eventData.title = !eventData.title && !eventData.member
          ? '(ブロック予約) ' + (eventData.note || '')
          : eventData.title;
        const status = eventData.title?.includes('ブロック予約')
          ? 4
          : (eventData.status ?? (eventData.isVisit ? 6 : 5));
        const color = STATUS_COLORS[status] ?? STATUS_COLORS[5];
        return {
          ...eventData,
          start: eventData.startedAt,
          end: eventData.endedAt,
          title: eventData.title || `${
            eventData.reservationMenu?.menuType === 1 ? '(見学) ' : ''
          }${eventData.reservationMenu?.menuName}\n${eventData.member?.lastName} ${eventData.member?.firstName}`,
          ...color,
        };
      },
      datesSet: (info: any) => {
        this.calendar?.removeAllEventSources();
        if (['timeGridDay', 'listDay'].includes(info.view.type)) {
          this.calendar?.addEventSource(this.items);
        } else {
          this.calendar?.addEventSource(this.summarize(this.items));
        }
        void this.refreshHolidayEvents(info.start, info.end);
      },
      eventDidMount: (info: any) => {
        if (info.event?._def?.extendedProps?.type === 'holiday') return;
        const titleEl = info.el.querySelector('.fc-event-title');
        if (titleEl) titleEl.style.fontSize = '1rem';
        if (info.view.type === 'listDay') {
          const eventEl = info.el.querySelector('.fc-list-event-graphic');
          if (eventEl) {
            const status = info.event.extendedProps.status ?? 4;
            const statusLabel = document.createElement('span');
            if (!info.event?.title?.includes('ブロック予約')) {
              statusLabel.textContent = STATUS_TEXT[status] ?? '';
              statusLabel.style.marginLeft = '0.5rem';
            }
            eventEl.appendChild(statusLabel);
          }
          const eventTimeEl = info.el.querySelector('.fc-list-event-time');
          const eventTitleEl = info.el.querySelector('.fc-list-event-title > a');
          const splitTitle = info.event?.title?.split('\n');
          if (eventTimeEl && eventTitleEl && splitTitle?.length) {
            eventTimeEl.style.whiteSpace = 'nowrap';
            eventTimeEl.style.overflow = 'hidden';
            eventTimeEl.style.textOverflow = 'ellipsis';
            const spanObj = document.createElement('span');
            spanObj.textContent = splitTitle[0];
            spanObj.style.marginLeft = '1rem';
            eventTimeEl.appendChild(spanObj);
            eventTitleEl.textContent = splitTitle.length > 1 ? splitTitle[1] : ' ';
          }
        }
      },
      eventClick: (info: any) => {
        if (info.event?._def?.extendedProps?.type === 'holiday') return;
        if (info.view.type === 'timeGridWeek') {
          this.calendar?.changeView('timeGridDay', info.event.start);
        } else {
          const id = info.event.id;
          const values = JSON.parse(JSON.stringify(info.event._def.extendedProps));
          const item = { id, ...values };
          this.setSelectReservation(item);
          this.showReservationModal = true;
        }
      },
    });
    this.calendar.render();
  }

  async onStudioChange(): Promise<void> {
    this.overduePageIndex = 0;
    this.items = [];
    this.overdueTasks = [];
    if (!this.selectedStudio) {
      this.studioSelection.clear(SESSION_KEY);
      this.restoredStudioLoaded = false;
      this.refreshCalendarEvents();
      return;
    }
    this.studioSelection.save(this.selectedStudio, SESSION_KEY);
    await this.load();
  }

  toggleShowOverdueTasks(): void {
    this.showOverdueTasks = !this.showOverdueTasks;
    if (!this.showOverdueTasks) {
      this.load();
    }
  }

  async load(): Promise<void> {
    if (!this.selectedStudio) return;
    this.isButtonDisabled = true;
    this.searching = true;
    try {
      this.schedules = [];
      this.items = [];
      const [scheduleData, reservationData] = await Promise.all([
        this.ptScheduleService.getAll(this.selectedStudio.id) as Promise<any[]>,
        this.ptReservationService.getAll(this.selectedStudio.id) as Promise<any[]>,
      ]);
      (scheduleData ?? []).forEach((v: any) => {
        const mainStart = businessDayjs(v.startedAt).format('HH:mm');
        const mainEnd = businessDayjs(v.endedAt).format('HH:mm');
        const subStart = v.reservationScheduleMask ? businessDayjs(v.reservationScheduleMask.startedAt).format('HH:mm') : '';
        const subEnd = v.reservationScheduleMask ? businessDayjs(v.reservationScheduleMask.endedAt).format('HH:mm') : '';
        this.schedules.push({
          date: v.reservationDate,
          main: `${mainStart}~${mainEnd} 合計: ${v.supportedNum} PT: ${v.supportedPtNum}`,
          sub: v.reservationScheduleMask ? `${subStart}~${subEnd} 受付停止` : '',
        });
      });
      const all = reservationData ?? [];
      this.items = all.filter((item: any) => !(!item.member && item.reservationMenu));
      this.overdueTasks = all
        .filter((d: any) =>
          (d.status === 0 || d.status === 1) &&
          businessDayjs(d.startedAt).tz('Asia/Tokyo').isBefore(businessDayjs().tz('Asia/Tokyo').startOf('day'), 'day')
        )
        .sort((a: any, b: any) => a.startedAt < b.startedAt ? -1 : a.startedAt > b.startedAt ? 1 : 0);
      this.overduePageIndex = Math.min(this.overduePageIndex, Math.max(0, this.overdueTotalPages - 1));
      this.refreshCalendarEvents();
    } finally {
      this.searching = false;
      setTimeout(() => { this.isButtonDisabled = false; }, 5000);
    }
  }

  private async loadRestoredStudio(): Promise<void> {
    if (this.restoredStudioLoaded || !this.viewInitialized || !this.calendar || !this.selectedStudio) return;
    this.restoredStudioLoaded = true;
    await this.load();
  }

  private refreshCalendarEvents(): void {
    if (!this.calendar) return;
    this.calendar.batchRendering(() => {
      this.calendar?.removeAllEventSources();
      if (!this.selectedStudio) return;
      const view = this.calendar?.view;
      if (view && ['timeGridDay', 'listDay'].includes(view.type)) {
        this.calendar?.addEventSource(this.items);
      } else {
        this.calendar?.addEventSource(this.summarize(this.items));
      }
    });
    void this.refreshHolidayEvents(this.calendar.view.activeStart, this.calendar.view.activeEnd);
    setTimeout(() => {
      this.calendar?.render();
      this.calendar?.updateSize();
    }, 0);
  }

  private async refreshHolidayEvents(start: Date, end: Date): Promise<void> {
    if (!this.calendar) return;
    const loadId = ++this.holidayLoadId;
    try {
      const events = await loadJapaneseHolidayEvents(start, end);
      if (!this.calendar || loadId !== this.holidayLoadId) return;
      this.calendar.getEventSourceById(JAPANESE_HOLIDAY_SOURCE_ID)?.remove();
      this.calendar.addEventSource({ id: JAPANESE_HOLIDAY_SOURCE_ID, events });
    } catch (error) {
      console.warn('日本祝日カレンダーの取得に失敗しました。', error);
    }
  }

  setSelectReservation(item: any): void {
    this.ptPageIndex = 0;
    this.isConfirmation = false;
    this.confirmAction = null;
    this.selectReservation = {};
    this.ptTransactions = [];
    this.selectReservation = item;
    this.selectReservation.targetDay = businessDayjs(item.startedAt).format('YYYY/MM/DD(ddd)');
    this.selectReservation.targetStart = businessDayjs(item.startedAt).format('HH:mm');
    this.selectReservation.targetEnd = businessDayjs(item.endedAt).format('HH:mm');
    if (item.member) {
      this.selectReservation.memberName = `${item.member.lastName} ${item.member.firstName}(${item.member.lastNameKana} ${item.member.firstNameKana})`;
      this.memberService.getTransaction(item.member.id).then((data: any) => {
        this.ptTransactions = (data ?? []).filter((v: any) => v.chargeType === 4);
      });
    } else {
      this.selectReservation.memberName = 'ブロック予約';
    }
    this.selectReservation.statusStr = STATUS_TEXT[item.status] ?? '';
  }

  showConfirm(action: string): void {
    this.isConfirmation = true;
    this.confirmAction = action;
  }

  selectMember(memberId: number): void {
    this.selectedMember = null;
    if (memberId) {
      this.selectedMember = this.memberList.find(m => m.id === memberId) ?? null;
    }
  }

  openCreateModal(): void {
    this.searchText = '';
    this.newReservation = {};
    this.selectedMember = null;
    this.memberList = [];
    this.menuList = [];
    if (!this.selectedStudio) return;
    this.studioService.getMember(this.selectedStudio.id).then((data: any) => {
      this.memberList = (data ?? [])
        .filter((d: any) => d.status === 0)
        .map((d: any) => ({ id: d.id, name: `${d.memberCode} ${d.lastName} ${d.firstName}`, data: d }))
        .sort((a: any, b: any) => a.name.localeCompare(b.name));
    });
    this.ptMenuService.getAll(this.selectedStudio.id).then((data: any) => {
      this.menuList = (data ?? []).filter((d: any) => d.menuType === 0).map((d: any) => ({
        id: d.id,
        displayName: `${d.menuName} (${d.requiredTime}分・${Math.floor(d.product?.amount * (1 * d.product?.taxRate?.rate + 1)).toLocaleString()}円)`,
        product: d.product,
      }));
    });
    this.showCreateModal = true;
  }

  openDummyModal(): void {
    this.dummyReservation = {};
    this.showDummyModal = true;
  }

  async saveNew(): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext)) return;
    if (!this.selectedStudio) return;
    const json: any = {
      studioId: this.selectedStudio.id,
      memberId: this.newReservation.memberId,
      reservationMenuId: this.newReservation.reservationMenuId,
    };
    const selectMenu = this.menuList.find(m => m.id === json.reservationMenuId);
    if (selectMenu) {
      json.amount = Math.floor(selectMenu.product?.amount * (1 * selectMenu.product?.taxRate?.rate + 1));
      json.taxAmount = json.amount - selectMenu.product?.amount;
      json.taxRate = selectMenu.product?.taxRate?.rate;
    }
    json.startedAt = `${this.newReservation.targetDay} ${this.newReservation.startTime}`;
    const result = await this.ptReservationService.create(json);
    // 旧版 pt-reservation.js:418-425
    if (!result?.success) {
      this.flash.create('danger', result?.error || 'エラーが発生しました。(DF)');
    } else {
      this.flash.create('success', '予約が完了しました。');
    }
    this.showCreateModal = false;
    await this.load();
  }

  async save(action: 'confirm' | 'complete'): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext)) return;
    const json: any = { id: this.selectReservation.id };
    if (action === 'confirm') json.status = 1;
    if (action === 'complete') json.status = 2;
    await this.ptReservationService.update(json);
    this.showReservationModal = false;
    await this.load();
  }

  async remove(): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext)) return;
    await this.ptReservationService.remove({ id: this.selectReservation.id });
    this.showReservationModal = false;
    await this.load();
  }

  async destroy(): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext)) return;
    await this.ptReservationService.destroy({ id: this.selectReservation.id });
    this.showReservationModal = false;
    await this.load();
  }

  async dummy(): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext)) return;
    if (!this.selectedStudio) return;
    const json = { ...this.dummyReservation, studioId: this.selectedStudio.id };
    await this.ptReservationService.dummy(json);
    this.showDummyModal = false;
    await this.load();
  }

  private summarize(allItems: any[]): any[] {
    const data = allItems.filter(v => v.status !== 3);
    return [...new Set(data.map(item =>
      `${item.startedAt}<>${item.endedAt}<>${item.reservationMenu?.menuType === 1}<>${!item.reservationMenuId}`
    ))].map((key, index) => {
      const [startedAt, endedAt, nonPt, nonMenu] = key.split('<>');
      const isVisit = nonPt === 'true';
      const isBlock = nonMenu === 'true';
      return {
        id: index + 1,
        isVisit,
        startedAt,
        endedAt,
        title: `${data.filter(item => {
          const itemIsVisit = item.reservationMenu?.menuType === 1;
          return item.startedAt === startedAt && item.endedAt === endedAt &&
            itemIsVisit === isVisit && !item.reservationMenuId === isBlock;
        }).length}${isVisit ? '\n(見学)' : ''}${isBlock ? '\n(ブロック予約)' : ''}`,
      };
    });
  }

  private getScheduleDate(): { id: string; name: string }[] {
    const today = businessDayjs().tz('Asia/Tokyo').startOf('day');
    const nextMonthEnd = today.add(1, 'month').endOf('month');
    const diffDays = nextMonthEnd.diff(today, 'day') + 1;
    return Array.from({ length: diffDays }, (_, i) => {
      const date = today.add(i, 'day');
      return { id: date.format('YYYY-MM-DD'), name: date.format('YYYY/MM/DD(ddd)') };
    });
  }

  private getScheduleTime(): { id: string; name: string }[] {
    const arrLen = (60 / RESERVE_SLOT) * (RESERVE_END - RESERVE_START) + 1;
    const modify = (60 / RESERVE_SLOT) * RESERVE_START;
    return Array.from({ length: arrLen }, (_, i) => {
      const time = businessDayjs().startOf('day').add((i + modify) * RESERVE_SLOT, 'minute').format('HH:mm');
      return { id: time, name: time };
    });
  }
}
